import { BubbleLegend } from './bubble-legend.component';
export default BubbleLegend;
